import { combineReducers } from 'redux';

import zipCodesReducer from './zipCodesReducer';
import analyticsReducer from './analyticsReducer';
import doctorsListReducer from './doctorsListReducer'
import patientListReducer from './patientListReducer';
import assessmentRecordListReducer from './assessmentRecordListReducer';
import loginReducer from './loginReducer';

const appReducer = combineReducers({
  analytics: analyticsReducer,
  zipCodes: zipCodesReducer,
  doctors: doctorsListReducer,
  patient: patientListReducer,
  login: loginReducer,
  assessmentrecord: assessmentRecordListReducer,
 
});

const rootReducer = (state, action) => {
  
  // when a logout action is dispatched it will reset redux state
  if (action.type === 'USER_LOGOUT') {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
